//import axios,{get_axios_data } from "@/pcomponents/common/axios/index";
import axios from 'axios';

export const setAxiosDefaultHeader=()=>{
  //axios.defaults.withCredentials = true;
  axios.defaults.headers.common['Authorization'] = localStorage.login_token;
};

export const get_axios_data=()=>{
  return {
    headers:{
      Authorization:localStorage.login_token
    },
    //withCredentials:true,
  };
};

export default axios;